import api from "../lib/api.ts";

export const subscribe = async (email: string) => {
  const response = await api.post("/emailsubscriptions", { email });
  return response.data;
};